import React from 'react'
import App from './App'
import ReactDOM from 'react-dom/client'
import { AuthProvider } from './contexts/auth-context'
import { UIProvider } from './contexts/UIContext'
import { FullscreenProvider } from './contexts/screen-context'
import { ProjectProvider } from './contexts/project-context'
import { BrandFilterProvider as DivisionProvider } from './contexts/brand-filter-context'
import './index.css'
import 'antd/dist/antd.min.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <AuthProvider>
    <UIProvider>
      <FullscreenProvider>
        <DivisionProvider>
          <ProjectProvider>
            <App />
          </ProjectProvider>
        </DivisionProvider>
      </FullscreenProvider>
    </UIProvider>
  </AuthProvider>,
)
